export const StepEnum = {
    INSTRUCTIONS: 'instructions',
    REVIEW: 'review',
    SUBMISSION: 'submission',
    PAYMENT: 'payment',
    RECORD: 'record'
};

export const stepOrder = [
    StepEnum.INSTRUCTIONS,
    StepEnum.REVIEW,
    StepEnum.SUBMISSION,
    StepEnum.PAYMENT,
    StepEnum.RECORD
];
